import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    MarkThreadAsRead as MarkThreadAsReadMutation,
    MarkThreadAsReadVariables as MarkThreadAsReadVariables,
} from 'nutshell-graphql-types';

import MARK_THREAD_AS_READ from '../mutations/mark-thread-as-read.graphql';

export const useMarkThreadAsRead = (): {
    markThreadAsRead: (arg1: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [markThreadAsRead, {loading, error}] = useMutation<
        MarkThreadAsReadMutation,
        MarkThreadAsReadVariables
    >(MARK_THREAD_AS_READ);

    return {
        markThreadAsRead: (threadId: string) =>
            markThreadAsRead({
                variables: {threadId},
                optimisticResponse: {
                    markThreadAsRead: {
                        __typename: 'Thread',
                        id: threadId,
                        isUnread: false,
                    },
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
